import { Component, Inject, OnInit } from '@angular/core';
import { MatDialog, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Router } from '@angular/router';

export interface DialogData {
  isSOC: boolean,
  isSupport: boolean,
  nspObj: ""
  NSPemail: "",
  NSPphone: "",
  NSPsoc: "",
  nspTitle: "",
  nspTitleContacts: "",
  nspDescription: "",
  nspEmailTranslation: "",
  nspSOCTranslation: "",
  nspSOCLinkTranslation: "",
  nspPhoneTranslation: "",
  openTicket: "",
  openContacts: "",
  customMessage: "";
}

@Component({ standalone: false,
  selector: 'vfa-cp-renewal-error-dialog',
  templateUrl: './renewal-error-dialog.component.html',
  styleUrls: ['./renewal-error-dialog.component.scss'],
})
export class RenewalErrorDialogComponent implements OnInit {

  constructor(@Inject(MAT_DIALOG_DATA) public data: DialogData, private router: Router, private dialog: MatDialog){}
  public contactUs: boolean = false;

  ngOnInit() {
    this.contactUs = this.data.isSupport? false : true;
  }

  navigateBySupportNew() {
    this.router.navigateByUrl("dashboard/support/case/new");
    this.dialog.closeAll();
  }
}

